import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment.prod';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class LoansandoverdrawnbankSoletraderService {

  URl = this.ConfigService.getAPIBaseUrl() + 'api/LoansandoverdrawnbankSoletrader'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertdetails(data: any) {
    return this.http.post(this.URl + '/InsertLoansandoverdrawnbankSoletrader', data)
  }
  getdata(APPeriodId: any) {
    return this.http.get(this.URl + '/GetLoansandoverdrawnbankSoletrader?APPeriodId=' + APPeriodId)
  }
  getdata_LY(APPeriodId: any) {
    return this.http.get(this.URl + '/GetLoansandoverdrawnbankSoletrader_LY?APPeriodId=' + APPeriodId)
  }
} 
